var React = require('react');

function ExclamationCircleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}));
}

ExclamationCircleInline.defaultProps = {"fill":"none","viewBox":"0 0 24 24","stroke":"currentColor"};

module.exports = ExclamationCircleInline;

ExclamationCircleInline.default = ExclamationCircleInline;
